import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { DispatchType } from "../../interfaces/redux.interface";
import { post } from "../../redux/ApiHelper";
import { successToast } from "../../utils/toast.util";
import { TrialClassType } from "../../interfaces/trial-class.interface";

interface RejectModal {
  adminRejectionReason: string;
}
const RejectModal = ({
  isOpen,
  closeModal,
  isEdit,
  editData,
  onSuccess,
}: {
  isOpen: boolean;
  closeModal: () => void;
  isEdit?: boolean;
  editData?: TrialClassType;
  onSuccess?: () => void;
}) => {
  const dispatch: DispatchType = useDispatch();
  const [adminRejectionReasonData, setadminRejectionReasonData] =
    useState<RejectModal>({
      adminRejectionReason: "",
    });
  const [isDisabled, setIsDisabled] = useState(true);
  const [errors, setErrors] = useState({
    adminRejectionReason: "",
  });

  const handleClickReject = async (
    trialClassId: string,
    adminRejectionReason: string
  ) => {
    try {
      post(`/admin/trial-class/rejected/${trialClassId}`, { adminRejectionReason }).then((res) => {
        successToast(res.message);
        closeModal();
        if (onSuccess) {
          onSuccess();
        }
      }).catch((error) => {
        console.error("Error rejecting trial class:", error);
      });
    } catch (error) {
      console.error("Error rejecting trial class:", error);
    }
  };

  useEffect(() => {
    if (isEdit && editData) {
      setadminRejectionReasonData({
        ...editData,
      });
    } else {
      setadminRejectionReasonData({
        adminRejectionReason: "",
      });
    }
  }, [isEdit, editData]);

  useEffect(() => {
    const { adminRejectionReason } = adminRejectionReasonData;

    const isDisabled = !adminRejectionReason;

    setIsDisabled(isDisabled);
    // Update error messages
    const errors = {
      adminRejectionReason: !adminRejectionReason
        ? "Rejection reason is required"
        : "",
    };

    setErrors(errors);
  }, [adminRejectionReasonData]);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    setadminRejectionReasonData({
      ...adminRejectionReasonData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    if (editData && editData._id) {
      handleClickReject(
        editData._id,
        adminRejectionReasonData.adminRejectionReason
      );
    }
  };

  if (!isOpen) return null; // Don't render the modal if it's not open

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full max-w-lg mx-4 p-6 rounded-lg shadow-lg max-h-screen overflow-auto">
        {/* Header */}
        <div className="mb-4">
          <h2 className="text-xl font-semibold text-gray-800">
            {isEdit && editData ? "Update" : "Add"} rejection reason
          </h2>
        </div>

        {/* Input Fields */}
        <div className="space-y-4">
          <div>
            <label
              htmlFor="adminRejectionReason"
              className="block text-left text-gray-700"
            >
              Enter rejection reason
            </label>
            <input
              type="text"
              name="adminRejectionReason"
              value={adminRejectionReasonData.adminRejectionReason}
              onChange={handleChange}
              placeholder="Rejection reason"
              className={`w-full px-4 py-2 border ${errors.adminRejectionReason
                  ? "border-red-500"
                  : "border-gray-300"
                } rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
            />
            {errors.adminRejectionReason && (
              <span className="text-red-500 text-sm text-left pl-1">
                {errors.adminRejectionReason}
              </span>
            )}
          </div>
        </div>

        {/* Actions */}
        <div className="mt-6 flex justify-end space-x-3">
          <button
            onClick={closeModal}
            className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 text-white bg-yellow-600 rounded-md hover:bg-yellow-700 transition disabled:opacity-50"
            disabled={isDisabled}
          >
            {isEdit && editData ? "Update" : "Add"} rejection reason
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectModal;
